import type { RouteObject } from "react-router";

/**
 * No loader guard: this app is public by default, and the page offers sign-in in place through
 * `auth.RequireCustomer` rather than redirecting. The API is the control (`salon.customer`).
 *
 * Loaded on demand, like the booking flow, so it is not on the home page's first paint
 * (TDD-SA NFR-SA-009).
 */
export const myAppointmentsRoutes: RouteObject[] = [
  {
    path: "appointments",
    lazy: async () => ({ Component: (await import("./pages/MyAppointmentsPage")).MyAppointmentsPage }),
  },
];
